import router, { resetRouter } from "Router";
import axios from "axios";
import qs from "qs";
import apps from "API";
import i18n from "Helpers/i18n";
import WebGLInfo from "webgl-info";

const gl = WebGLInfo();

const MOBILE_BREAKPOINT = 992;
const TABLET_BREAKPOINT = 1200;

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function _createWwwcPreset(id, title, value, voi) {
  return {
    id: id,
    title: title,
    value: value,
    voi: voi,
  };
}

const state = {
  isConsoleOpen: true,
  subsPlans: [{ empty: true }, {}, {}],
  agent:
    window.navigator.userAgent.substr(window.navigator.userAgent.length - 3) ===
    "app",
  windowWidth: window.innerWidth,
  segmentationActionInProccess: false,
  authModalStatus: false,
  subsModalStatus: false,
  verifyModalStatus: false,
  verifyModalInfo: undefined,
  activeChatWidget: null,
  modules: [
    {
      id: "community",
      url: "/community/cases",
      accessInstallations: "ru",
      mobileIcon: "fa-comments",
      collapsedMinWidth: 360,
      collapsedRightType: 2,
      viewerBackPath: "/community/cases/:caseId",
      accept: [
        "application/dicom",
        "",
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/tiff",
      ],
    },
    {
      id: "AI",
      url: "/AI/services",
      mobileIcon: "fa-brain-circuit",
      collapsedMinWidth: 80,
      collapsedRightType: 1,
      viewerBackPath: "/AI/studies",
      accept: ["application/dicom", ""],
      acceptIfDisabledFilter: [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/tiff",
      ],
    },
    {
      id: "edu",
      url: "/edu/services",
      accessInstallations: "ru",
      mobileIcon: "fa-graduation-cap",
      collapsedRightType: 1,
      viewerBackPath: "/edu/services/:serviceId/lessons/:lessonId/studies",
      accept: [
        "application/dicom",
        "",
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/tiff",
      ],
    },
  ],
  readyMPR: false,
  studiesListPageNumber: 1,
  currentViewStudy: {},
  bodyclick: false,
  studyBanner: null,
  isMPR: false,
  syncMode: false,
  langs: process.env.VUE_APP_LANGS.split(",").map((lang) => {
    return {
      value: lang.toLowerCase(),
      label: lang.toUpperCase(),
    };
  }),
  currentSerie: null,
  seriesList: [],
  // Soft Tissue 360/60
  // Lung 1500/-500
  // Liver 150/90
  // Bone 4000/600
  // Brain 80/40
  presets: [
    _createWwwcPreset(1, "Chest/Abdomen", "360 / 60", {
      windowWidth: 360,
      windowCenter: 60,
    }),

    _createWwwcPreset(2, "Bone", "4000 / 600", {
      windowWidth: 4000,
      windowCenter: 600,
    }),
    _createWwwcPreset(
      3,
      "Lung",
      "1500 / -500",

      { windowWidth: 1500, windowCenter: -500 }
    ),
    _createWwwcPreset(4, "Brain", "80 / 40", {
      windowWidth: 80,
      windowCenter: 40,
    }),

    _createWwwcPreset(5, "Liver", "200 / 100", {
      windowWidth: 200,
      windowCenter: 100,
    }),
    _createWwwcPreset(0, "Default"),
    // _createWwwcPreset(3, "Liver", "150 / 90", {
    //   windowWidth: 150,
    //   windowCenter: 90,
    // }),
  ],
  isUpload: false,
  token: localStorage.getItem("ptmviewerauthtoken"),
  statuses: {
    none: {
      color: "gray",
    },
    proccess: {
      color: "yellow",
    },
    not_found: {
      color: "green",
    },
    found: {
      color: "red",
    },
  },
  uploadWays: [
    {
      id: "directory",
      attributes: [
        {
          key: "webkitdirectory",
          value: null,
        },
        {
          key: "multiple",
          value: null,
        },
      ],
    },
    // {
    //   id: "zip",
    //   attributes: [
    //     {
    //       key: "multiple",
    //       value: null,
    //     },
    //   ],
    //   accept:
    //     "zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed",
    // },
    {
      id: "zip",
      attributes: [
        {
          key: "multiple",
          value: null,
        },
      ],
    },
  ],
  user: null,
  invert: false,
  isPlaying: false,
  activeTools: ["Zoom"],
  toolsGroups: [
    {
      id: "general",
      icon: null,
      popover: false,
    },
    {
      id: "zooming",
      icon: "fa-light fa-magnifying-glass",
      popover: false,
    },
    {
      id: "annotation",
      icon: "fa-ruler",
      popover: false,
    },
    {
      id: "rotating",
      icon: "fa-undo",
      popover: false,
    },
    {
      id: "segmentation",
      icon: "fa-paintbrush",
      popover: false,
    },
  ],
  tools: [
    {
      group: "general",
      id: "Pan",
      icon: "fa-light fa-arrows-up-down-left-right",
      hotkey: {
        type: "Auxiliary",
        icon: "computer-mouse-middle.svg",
      },
    },
    {
      group: "general",
      id: "StackScroll",
      icon: "fa-regular fa-layer-group",
      show: true,
      hotkey: {
        icon: "computer-mouse-middle.svg",
      },
    },
    {
      group: "general",
      show: false,
      id: "WindowLevel",
      old_id: "Wwwc",
      icon: "fa-lightbulb-o",
    },
    {
      group: "zooming",
      id: "Magnify",
      icon: "fa-light fa-magnifying-glass-plus",
    },
    {
      group: "zooming",
      id: "Zoom",
      icon: "fa-search",
      default: true,
      hotkey: {
        type: "Secondary",
        icon: "computer-mouse-right.svg",
      },
      configuration: {
        invert: false,
        preventZoomOutsideImage: true,
        minScale: -100,
        maxScale: 40.0,
        zoomToCenter: false,
        minZoomScale: 0.02,
        maxZoomScale: 30,
        pinchToZoom: true,
        pan: true,
      },
    },
    {
      group: "rotating",
      id: "Screen",
      icon: "fa-camera",
      not_cornerstone: true,
    },
    {
      group: "rotating",
      id: "Rotate",
      not_cornerstone: true,
      icon: "fa-solid fa-arrows-rotate",
    },
    {
      group: "rotating",
      id: "Flip",
      not_cornerstone: true,
      icon: "fa-duotone fa-border-center-v",
    },
    {
      group: "rotating",
      id: "Reset",
      icon: "fa-undo",
      not_cornerstone: true,
      default: true,
    },
    // {
    //   group: "none",
    //   id: "Eraser",
    //   icon: "fa-eraser",
    // },
    {
      id: "ArrowAnnotate",
      group: "annotation",
      icon: "fa-arrow-up-left",
      configuration: {
        getTextCallback: (t) => {
          const text =
            window.location.hostname === "demo.aiopinion.ai" ||
            window.location.hostname === "en-dev.demo.thirdopinion.ai"
              ? "Enter description"
              : "Напишите подпись";
          return t(prompt(text + ":"));
        },
      },
    },
    {
      group: "none",
      id: "Bidirectional",
      icon: "fa-cross",
    },
    {
      group: "annotation",
      id: "Angle",
      icon: "fa-angle",
    },
    {
      group: "annotation",
      id: "EllipticalROI",
      old_id: "EllipticalRoi",
      icon: "fa-circle",
    },
    {
      group: "annotation",
      id: "PlanarFreehandROI",
      configuration: {
        cachedStats: true,
      },
      old_id: "FreehandRoi",
      icon: "fa-burst",
    },
    {
      group: "annotation",
      id: "Length",
      default: true,
      icon: "fa-ruler",
    },
    {
      group: "none",
      id: "Probe",
      icon: "fa-circle",
      // show: true,
    },
    {
      group: "none",
      id: "RectangleROI",
      old_id: "RectangleRoi",
      icon: "fa-square-o",
    },
    {
      group: "general",
      id: "ReferenceCursors",
      icon: "fa-crosshairs",
      old_id: -1,
      not_tail: true,
      configuration: {
        shadow: true,
        preventHandleOutsideImage: false,
        displayThreshold: 5,
        positionSync: true,
        disableCursor: true,
      },
    },
    // {
    //   group: "none",
    //   id: "TextMarker",
    //   icon: "fa-text-height",
    //   configuration: {
    //     markers: ["F5", "F4", "F3", "F2", "F1"],
    //     current: "F5",
    //     ascending: true,
    //     loop: true,
    //   },
    // },

    {
      group: "none",
      id: "DragProbe",
      icon: "fa-dot-circle-o",
    },
    {
      group: "none",
      id: "ScaleOverlay",
      icon: "fa-terminal",
    },
    // {
    //   group: "none",
    //   id: "OrientationMarkers",
    //   icon: "fa-map-marker",
    // },

    {
      group: "segmentation",
      id: "Brush",
      default: true,
      seg_type: "Circular",
      icon: "fa-paintbrush",
    },
    // {
    //   group: "segmentation",
    //   id: "CircleScissors",
    //   icon: "fa-circle",
    // },
    // {
    //   group: "segmentation",
    //   id: "FreehandScissors",
    //   icon: "fa-bezier-curve",
    // },
    // {
    //   group: "segmentation",
    //   id: "RectangleScissors",
    //   icon: "fa-square-o",
    // },
    {
      group: "general",
      id: "Crosshairs",
      old_id: "Crosshairs",
      icon: "fa-crosshairs",
    },
    // {
    //   group: "general",
    //   id: "Dublicate",
    //   icon: "fa-copy",
    //   not_cornerstone: true,
    // },
  ],
  syncTool: [
    {
      id: "scroll",
      tool_id: "StackScroll",
      enable: false,
    },
    // {
    //   id: "wwwc",
    //   enable: false,
    // },
    // {
    //   id: "zoom",
    //   tool_id: "Zoom",
    //   enable: false,
    // },
    // {
    //   id: "pan",
    //   enable: false,
    // },
  ],
  currentGrids: {
    info: {
      row: 1,
      col: 1,
    },
    grids: [1],
  },
  userLinks: {
    ru: {
      privacyPolicy: "https://thirdopinion.ai/policy",
      userAgreement: "https://thirdopinion.ai/terms_of_use",
      userRegisterLink: "https://thirdopinion.ai/signup",
      personalData: "https://thirdopinion.ai/personaldata",
      calcRequest: "https://thirdopinion.ai/request",
      calcMethod: "https://thirdopinion.ai/methodology_calc",
      marketing_consent: "https://thirdopinion.ai/advertising_agreement",
    },
    en: {
      privacyPolicy: "https://aiopinion.ai/policy",
      userAgreement: "https://aiopinion.ai/terms_of_use",
      userRegisterLink: "https://aiopinion.ai/signup",
      personalData: "https://aiopinion.ai/personaldata",
      calcRequest: "https://aiopinion.ai/#contacts",
      calcMethod: "https://aiopinion.ai/calcmethodology",
    },
    kz: {
      privacyPolicy: "https://medailab.kz/policy",
      userAgreement: "https://medailab.kz/terms_of_use",
      userRegisterLink: "https://medailab.kz/signup",
      personalData: "https://medailab.kz/personaldata",
      calcRequest: "https://medailab.kz/request",
      calcMethod: "https://medailab.kz/methodology_calc",
    },
  },
};

const mobileCheck = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

const getters = {
  isSubscriptionDisplayed: () => {
    return i18n.locale === "ru";
  },

  isConsoleOpen: (state) => {
    return state.isConsoleOpen;
  },
  subsPlans: (state, getters) => {
    return !state.subsPlans[0]?.empty
      ? state.subsPlans
          .map((plan, index) => {
            const currentCost = plan.costs[0];
            plan.isActiveForUser = plan.id === state.user?.plan?.plan.id;
            plan.extId = index === 0 ? "base" : index === 1 ? "ext" : "corp";
            plan.button =
              plan.id < state.user?.plan?.plan.id || plan.id === 1
                ? null
                : {
                    active: plan.isActiveForUser,
                    class:
                      plan.isActiveForUser &&
                      state.user?.plan.auto_renew &&
                      !state.subsModalStatus
                        ? "demo__color--gradient-inner"
                        : undefined,
                    text: (plan.isActiveForUser
                      ? state.user?.plan.auto_renew
                        ? i18n.t("Subs.cancelSub")
                        : i18n.t("Subs.unsub.complete.recover")
                      : i18n.t("Subs.Connect")
                    ).toLowerCase(),
                    type:
                      plan.isActiveForUser && state.user?.plan.auto_renew
                        ? "simple"
                        : undefined,
                    action: plan.isActiveForUser
                      ? !state.user?.plan.auto_renew
                        ? "unsubCancel"
                        : "unsubscribe"
                      : "subscribe",
                  };
            const checkFree = parseInt(currentCost?.price);
            plan.cost =
              currentCost && checkFree
                ? currentCost.price.split(".")[0] +
                  " " +
                  currentCost.currency.symbol
                : i18n.t("Subs.Free");
            plan.costDescription =
              currentCost && checkFree
                ? i18n
                    .t("Subs.CostDesc")
                    .replace(
                      "<period>",
                      i18n.t("Subs." + currentCost?.interval)
                    )
                : undefined;
            return plan;
          })
          .concat(
            state.subsPlans.length < 3
              ? {
                  id: 1000,
                  name: i18n.t("Subs.CorpPlan.desc"),
                  description: undefined,
                  costs: [],
                  extId: "corp",
                  isActiveForUser: getters.userIsCorpSub,
                  background_image: undefined,
                  cost: i18n.t("Subs.CorpPlan.cost"),
                  is_featured: false,
                  discount_percentage: 0,
                  button: {
                    text: i18n.t("Subs.CorpPlan.request"),
                    action: "corpRequest",
                    type: "gray",
                  },
                  discount_valid_until: null,
                  terms_and_conditions: undefined,
                  features: [
                    { name: i18n.t("Subs.CorpPlan.feature_1") },
                    { name: i18n.t("Subs.CorpPlan.feature_2") },
                  ],
                }
              : undefined
          )
          .filter((sub) => !!sub)
      : state.subsPlans;
  },
  segmentationActionInProccess: (state) => {
    return state.segmentationActionInProccess;
  },
  userIsCorpSub: (state) => {
    return state.user?.plan
      ? !state.subsPlans.filter(
          (plan) => plan.id === state.user.plan?.plan.id
        )[0] ||
          (state.subsPlans.length > 2 &&
            state.subsPlans[state.subsPlans.length - 1].id ===
              state.user?.plan?.plan.id)
      : undefined;
  },
  userIsBaseSub: (state) => {
    return state.user?.plan ? state.user?.plan?.plan.id === 1 : undefined;
  },
  subsModalStatus: (state) => {
    return state.subsModalStatus;
  },
  verifyModalStatus: (state) => {
    return state.verifyModalStatus;
  },
  verifyModalInfo: (state) => {
    return state.verifyModalInfo;
  },
  authModalStatus: (state) => {
    return state.authModalStatus;
  },
  userLinks: (state, getters) => {
    const baseLinks = state.userLinks[process.env.VUE_APP_INSTALLATION] || {};
    if (process.env.VUE_APP_INSTALLATION === "ru") {
      return {
        ...baseLinks,
        privacyPolicy:
          baseLinks.privacyPolicy + (i18n.locale !== "ru" ? "_en" : "/"),
        personalData:
          baseLinks.personalData + (i18n.locale !== "ru" ? "_en" : ""),
        userAgreement:
          baseLinks.userAgreement + (i18n.locale !== "ru" ? "/en" : ""),
        marketing_consent:
          baseLinks.marketing_consent + (i18n.locale !== "ru" ? "_en" : ""),
      };
    }
    return baseLinks;
  },
  agent: (state) => {
    return state.agent;
  },
  isMobile: (state) => {
    return state.windowWidth < MOBILE_BREAKPOINT;
  },
  isTablet: (state) => {
    return state.windowWidth < TABLET_BREAKPOINT;
  },
  windowWidth: (state) => {
    return state.windowWidth;
  },
  modules: (state) => {
    return state.modules.filter(
      (module) =>
        !module.accessInstallations ||
        module.accessInstallations.indexOf(process.env.VUE_APP_INSTALLATION) !==
          -1
    );
  },

  readyMPR: (state) => {
    return state.readyMPR;
  },
  studiesListPageNumber: (state) => {
    return state.studiesListPageNumber;
  },
  isMPR: (state) => {
    return state.isMPR;
  },
  studyBanner: (state) => {
    return state.studyBanner;
  },
  MAX_TEXTURES_SIZE: () => {
    return gl &&
      gl.webgl1 &&
      gl.webgl1.maximum &&
      gl.webgl1.maximum.maxTextureSize
      ? gl.webgl1.maximum.maxTextureSize
      : undefined;
  },
  currentViewStudy: (state) => {
    return state.currentViewStudy;
  },
  bodyclick: (state) => {
    return state.bodyclick;
  },
  syncMode: (state) => {
    return state.syncMode;
  },
  langs: (state) => {
    return state.langs;
  },
  currentSerie: (state) => {
    return state.currentSerie;
  },
  seriesList: (state) => {
    return state.seriesList;
  },
  presets: (state) => {
    return state.presets;
  },
  token: (state) => {
    return state.token;
  },
  api: (state, getters) => {
    let routes = {};
    apps.map((app) => {
      app.routes.map((route) => {
        const headers =
          route.require_auth && getters.token
            ? {
                Authorization: "Token " + getters.token,
              }
            : {};
        routes[route.name] = axios.create({
          baseURL: app.baseURL + app.prefix + route.url,
          method: route.method,
          withXSRFToken: true,
          headers: {
            ...headers,
            Language: i18n.locale,
            "Accept-Language": i18n.locale,
            "X-CSRFTOKEN": getCookie("csrftoken"),
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
      });
    });
    return routes;
  },
  isUpload(state) {
    return state.isUpload;
  },
  statuses(state) {
    return state.statuses;
  },
  uploadWays(state) {
    return state.uploadWays;
  },
  isPlaying(state) {
    return state.isPlaying;
  },
  invert(state) {
    return state.invert;
  },
  toolsGroups(state) {
    return state.toolsGroups;
  },
  tools(state) {
    return state.tools;
  },
  activeTools(state) {
    return state.activeTools;
  },
  syncTool(state) {
    return state.syncTool;
  },
  currentGrids(state) {
    return state.currentGrids;
  },
  user(state) {
    return state.user;
  },
  activeChatWidget(state) {
    return state.activeChatWidget;
  },
};

const actions = {
  resetUser(context) {
    context.commit("resetUserHandler");
  },
  updateIsConsoleOpen(context, isConsoleOpen) {
    context.commit("updateIsConsoleOpenHandler", isConsoleOpen);
  },
  updateSubsPlans(context, subsPlans) {
    context.commit("updateSubsPlansHandler", subsPlans);
  },
  updateSegmentationActionInProccess(context, segmentationActionInProccess) {
    context.commit(
      "updateSegmentationActionInProccessHandler",
      segmentationActionInProccess
    );
  },
  updateSubsModalStatus(context, subsModalStatus) {
    context.commit("updateSubsModalStatusHandler", subsModalStatus);
  },
  updateVerifyModalStatus(context, verifyModalStatus) {
    context.commit("updateVerifyModalStatusHandler", verifyModalStatus);
  },
  updateVerifyModalInfo(context, verifyModalInfo) {
    context.commit("updateVerifyModalInfoHandler", verifyModalInfo);
  },
  updateAuthModalStatus(context, authModalStatus) {
    context.commit("updateAuthModalStatusHandler", authModalStatus);
  },
  removeSerie(context, serie) {
    context.commit("removeSerieHandler", serie);
  },
  updateWindowWidth(context, windowWidth) {
    context.commit("updateWindowWidthHandler", windowWidth);
  },
  updateReadyMPR(context, readyMPR) {
    context.commit("updateReadyMPRHandler", readyMPR);
  },
  updateStudiesListPageNumber(context, page) {
    context.commit("updateStudiesListPageNumberHandler", page);
  },
  updateCrosshairsTool(context, active) {
    context.commit("updateCrosshairsToolHandler", active);
  },
  updateIsMPR(context, isMPR) {
    context.commit("updateIsMPRHandler", isMPR);
  },
  updateStudyBanner(context, studyBanner) {
    context.commit("updateStudyBannerHandler", studyBanner);
  },
  updateCurrentViewStudy(context, currentViewStudy) {
    context.commit("updateCurrentViewStudyHandler", currentViewStudy);
  },
  updateBodyClick(context, bodyclick) {
    context.commit("updateBodyClickHandler", bodyclick);
  },
  updateUser(context, data) {
    context.commit("updateUserHandler", data);
  },
  setSerieStatus(context, data) {
    context.commit("setSerieStatusHandler", data);
  },
  updateSyncMode(context, syncMode) {
    context.commit("updateSyncModeHandler", syncMode);
  },
  tooglePopover(context, data) {
    context.commit("tooglePopoverHandler", data);
  },
  updateCurrentSerie(context, serie) {
    context.commit("updateCurrentSerieHandler", serie);
  },
  updateSeriesList(context, seriesList) {
    context.commit("updateSeriesListHandler", seriesList);
  },
  updateToken(context, token) {
    context.commit("updateTokenHandler", token);
  },
  updateIsUpload(context, isUpload) {
    context.commit("updateIsUploadHandler", isUpload);
  },
  updateIsPlaying(context, isPlaying) {
    context.commit("updateIsPlayingHandler", isPlaying);
  },
  updateInvert(context, invert) {
    context.commit("updateInvertHandler", invert);
  },
  logoutUser(context) {
    context.commit("logoutUserHandler");
  },
  updateActiveTools(context, activeTools) {
    context.commit("updateActiveToolsHandler", activeTools);
  },
  updateSyncTool(context, syncTool) {
    context.commit("updateSyncToolHandler", syncTool);
  },
  updateSyncToolActive(context, payload) {
    context.commit("updateSyncToolActiveHandler", payload);
  },
  updateGrid(context, grids) {
    context.commit("updateGridHandler", grids);
  },
  auth(context, user) {
    context.commit("authHandler", user);
  },
  openChat(context, { chatId, user }) {
    // Проверяем, есть ли уже активный чат
    if (context.state.activeChatWidget) {
      // Если чат уже открыт, закрываем его
      const { widget, container } = context.state.activeChatWidget;
      widget.unmount(container);
      document.body.removeChild(container);
      context.commit("setActiveChatWidgetHandler", null);
      return;
    }

    // Маунтим чат-виджет
    import("chatWidget/ChatWidget")
      .then((module) => {
        const chatWidget = module.default;

        // Создаем контейнер для чата
        const chatContainer = document.createElement("div");
        document.body.appendChild(chatContainer);

        // Сохраняем ссылку на активный виджет
        context.commit("setActiveChatWidgetHandler", {
          widget: chatWidget,
          container: chatContainer,
        });

        // Маунтим виджет
        chatWidget.mount(chatContainer, {
          user: {
            fullName: JSON.parse(JSON.stringify(user.fullName)),
            id: JSON.parse(JSON.stringify(user.id)),
          },
          chatType: "userChat",
          chatId: JSON.parse(JSON.stringify(chatId)),
          resize: true,
          fullscreen: true,
          onClose: () => {
            chatWidget.unmount(chatContainer);
            document.body.removeChild(chatContainer);
            context.commit("setActiveChatWidgetHandler", null);
          },
        });
      })
      .catch((error) => {
        console.error("Failed to mount chat widget:", error);
      });
  },
  closeChat(context) {
    if (context.state.activeChatWidget) {
      const { widget, container } = context.state.activeChatWidget;
      widget.unmount(container);
      document.body.removeChild(container);
      context.commit("setActiveChatWidgetHandler", null);
    }
  },
};

const mutations = {
  resetUserHandler(state) {
    state.user = undefined;
  },
  updateIsConsoleOpenHandler(state, isConsoleOpen) {
    state.isConsoleOpen = isConsoleOpen;
  },
  updateSubsPlansHandler(state, subsPlans) {
    state.subsPlans = subsPlans;
  },
  updateSubsModalStatusHandler(state, subsModalStatus) {
    state.subsModalStatus = subsModalStatus;
  },
  updateVerifyModalStatusHandler(state, verifyModalStatus) {
    state.verifyModalStatus =
      process.env.VUE_APP_VERIFY === "on" ? verifyModalStatus : false;
  },
  updateVerifyModalInfoHandler(state, verifyModalInfo) {
    state.verifyModalInfo = verifyModalInfo;
  },
  updateSegmentationActionInProccessHandler(
    state,
    segmentationActionInProccess
  ) {
    state.segmentationActionInProccess = segmentationActionInProccess;
  },
  updateAuthModalStatusHandler(state, authModalStatus) {
    state.authModalStatus = authModalStatus;
  },
  removeSerieHandler(state, serie) {
    state.seriesList = state.seriesList.filter((s) => {
      return s.seriesInstanceUid !== serie.seriesInstanceUid;
    });
  },
  updateWindowWidthHandler(state, windowWidth) {
    state.windowWidth = windowWidth;
  },
  updateReadyMPRHandler(state, readyMPR) {
    state.readyMPR = readyMPR;
  },
  updateStudiesListPageNumberHandler(state, page) {
    state.studiesListPageNumber = page;
  },
  updateCrosshairsToolHandler(state, active) {
    if (!active) {
      state.activeTools = state.activeTools.filter(
        (tool) => tool !== "Crosshairs"
      );
    } else {
      state.activeTools = state.activeTools.concat("Crosshairs");
    }
  },
  updateIsMPRHandler(state, isMPR) {
    state.isMPR = isMPR;
  },
  updateStudyBannerHandler(state, studyBanner) {
    state.studyBanner = studyBanner;
  },
  updateCurrentViewStudyHandler(state, currentViewStudy) {
    state.currentViewStudy = currentViewStudy;
  },
  updateBodyClickHandler(state, bodyclick) {
    state.bodyclick = bodyclick;
  },
  updateUserHandler(state, data) {
    if (data.updateFieldOnly) {
      state.user[data.updateFieldOnly.field] = data.updateFieldOnly.value;
    } else {
      state.user = !data.addExternalData
        ? data
        : {
            ...state.user,
            [data.addExternalData.field]: data.addExternalData.value,
          };
    }
  },
  setSerieStatusHandler(state, data) {
    state.seriesList = state.seriesList.map((serie) => {
      if (serie.seriesInstanceUid === data.serie_id) {
        serie = { ...serie, loading: data.loading, logs: data.logs };
      }
      return serie;
    });
  },
  updateSyncModeHandler(state, syncMode) {
    state.syncMode = syncMode;
  },
  tooglePopoverHandler(state, data) {
    state.toolsGroups.map((tool) => {
      if (tool.id === data.tool_id) {
        tool.popover = data.enable;
      } else {
        tool.popover = false;
      }
    });
  },
  updateCurrentSerieHandler(state, serie) {
    state.currentSerie = serie;
  },
  updateSeriesListHandler(state, seriesList) {
    state.seriesList = seriesList;
  },
  updateTokenHandler(state, token) {
    state.token = token;
    localStorage.setItem("ptmviewerauthtoken", token);
  },
  updateIsUploadHandler(state, isUpload) {
    state.isUpload = isUpload;
  },
  updateIsPlayingHandler(state, isPlaying) {
    state.isPlaying = isPlaying;
  },
  updateInvertHandler(state, invert) {
    state.invert = invert;
  },
  logoutUserHandler(state) {
    localStorage.removeItem("ptmviewerauthtoken");
    state.user = undefined;
    state.token = null;

    resetRouter();

    if (router.currentRoute.path !== "/") {
      router.push("/");
    }
    if (window?.$chatwoot) {
      window.$chatwoot.reset();
    }
  },
  updateActiveToolsHandler(state, activeTools) {
    state.activeTools = activeTools;
  },
  updateSyncToolHandler(state, syncTool) {
    state.syncTool = syncTool;
  },
  updateSyncToolActiveHandler(state, payload) {
    state.syncTool = state.syncTool.map((tool) => {
      if (tool.id === payload.tool_id) {
        tool.enable = payload.enable;
      }
      return tool;
    });
  },
  updateGridHandler(state, grids) {
    state.currentGrids = grids;
  },
  setActiveChatWidgetHandler(state, chatWidget) {
    state.activeChatWidget = chatWidget;
  },
  authHandler(state, user) {
    state.user = user;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
